// extracted by mini-css-extract-plugin
export default {"root":"AnchorifedText_root__JkCmt","default":"AnchorifedText_default__aqK76","white":"AnchorifedText_white__7JLLx"};